<template>
    <div class="zz" :class="{ active: isShowRechage }">
        <div class="modalBox">
            <div class="modal">
                <img class="top" src="~@/assets/chongzhi-top.png" alt="" />
                <div class="list">
                    <div
                        @click="changeRecharge(item.id)"
                        class="item"
                        v-for="item in rechargeConfigList"
                        :key="item.id"
                        :class="[selRechargeId == item.id ? 'active' : '']"
                    >
                        <div class="niubi">
                            {{ item.fund }}牛币
                            <span class="gift" v-if="item.gift > 0">
                                加送{{ item.gift }}牛币
                            </span>
                        </div>
                        <div class="price">
                            售价{{ item.fund }}.00元
                            <span v-if="item.coupon"
                                >送{{ item.coupon }}券</span
                            >
                        </div>
                    </div>
                </div>
                <div class="submit" @click="submit()">确定支付</div>
            </div>
            <img
                @click="close()"
                class="close"
                src="~@/assets/close.png"
                alt=""
            />
        </div>
    </div>
</template>

<script>
    import rx from "../../_rx";
    import userCenterService from "../../service/user-center.service";
    export default {
        name: "chongzhi",
        data() {
            return {
                isShowRechage: false,
                rechargeConfigList: [],
                selRechargeId: "",
            };
        },
        mounted() {
            rx.on("showChongzhi", () => {
                this.isShowRechage = true;
            });
            this.getRechargeConfig();
        },
        methods: {
            close() {
                this.isShowRechage = false;
            },
            getRechargeConfig() {
                userCenterService.getRechargeConfig().then((res) => {
                    this.rechargeConfigList = res.data;
                });
            },
            changeRecharge(id) {
                this.selRechargeId = id;
            },
            submit() {
                location.href = `http://lianghua.nbd.com.cn/c/Wxpay/recharge?goodsId=${this.selRechargeId}`;
            },
        },
    };
</script>

<style lang="scss" scoped src="./chongzhi.scss"></style>
